import { useEffect } from "react";

const isTokenExpired = () => {
  const expiryTime = localStorage.getItem("dexkor-chat-widget-token-expiry");
  if (!expiryTime) return true; // Treat as expired if no expiry time is found
  return Date.now() >= parseInt(expiryTime, 10);
};

const handleTokenExpiry = () => {
  if (isTokenExpired()) {
    localStorage.removeItem("dexkor-chat-widget-auth-token");
    localStorage.removeItem("dexkor-chat-widget-token-expiry");
  }
};

const useContinuousTokenChecking = () => {
  useEffect(() => {
    handleTokenExpiry();

    // Optional: Set up an interval to periodically check token expiration
    const intervalId = setInterval(() => handleTokenExpiry(), 60000); // Check every minute

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);
};

export default useContinuousTokenChecking;
